module.exports = __webpack_public_path__ + "files/27d281d7b971c1b8f11dab83a03d3d86.png";